import(/* webpackMode: "eager" */ "/app/app/[locale]/login/page.tsx");
